module.exports = __webpack_public_path__ + "img/rocketship-3.2924f64c.jpg";